<template>
    <layout-modal
        v-if="active"
        ref="modal"
    >
        <template #default>
            <div class="modal-inner-shadow mb-4">
                <account-loyalty-reward-ticket
                    :benefit-type="reward.benefit_type"
                    :title="reward.title_ticket"
                    :type="type"
                    :subtitle="reward.subtitle_ticket"
                />

                <img
                    :alt="$t('portal.rewards.qr_code')"
                    :src="qrCodeUrl"
                    class="max-w-64 h-auto mx-auto aspect-square my-10"
                />

                <p class="mt-2 mb-1 px-4 text-lg">
                    {{ $t("portal.rewards.value_now") }}:
                    <span
                        :class="{ 'whitespace-nowrap': reward.value_now != null }"
                        v-html="formatValueNow"
                    />
                </p>

                <p class="mb-8 px-4">{{ $t("portal.rewards.valid_until") }}: <span v-text="validTo" /></p>
            </div>
        </template>
    </layout-modal>
</template>

<script lang="ts" setup>
import type { Reward } from "~/types";
import type { LayoutModal } from "#components";

const props = defineProps<{
    reward: Reward;
    type: "voucher" | "coupon";
    active: boolean;
}>();

const { t } = useI18n();
const i18nLocale = useI18n();
const dayjs = useDayjs();
const baseUrl = useBaseUrl();

const modal = ref<typeof LayoutModal | null>(null);
const currency = "&euro;";

const locale = computed<string>(() => {
    return i18nLocale.locale.value;
});

const formatValueNow = computed(() => {
    if (!props.reward.value_now && props.reward.value_now !== 0) {
        return t("portal.rewards.value_unknown");
    }

    const val = parseFloat(props.reward.value_now + "");

    return (
        val.toLocaleString(locale.value, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }) +
        "&nbsp;" +
        currency
    );
});

const validTo = computed(() => {
    if (!props.reward.valid_to) {
        return t("portal.rewards.valid_until_unknown");
    }

    return dayjs.utc(props.reward.valid_to).format("DD.MM.YYYY");
});

const qrCodeUrl = computed(() => {
    return `${baseUrl}api/rewards/download/${props.reward.code}/qr-code`;
});

defineExpose({
    open: () => {
        modal.value?.open();
    },
});
</script>
